import { CameraManager } from "../../utils/CameraManager";
import { ColorPalette } from "./ColorPalette";
import { GameVars } from "../../GameVars";
import { GameManager } from "../../GameManager";
import { GameConstants } from "../../GameConstants";
import { CanvasManager } from "../Board/CanvasManager";
import { PaletteElement } from "./PaletteElement";
import { RavalButton, RavalProgressBar } from "../../utils/Utils";
import { AudioManager } from "../../AudioManager";
import { CanvasScene } from "../Board/CanvasScene";

export class GuiScene extends Phaser.Scene {

    public static currentInstance: GuiScene;

    public palette: ColorPalette;
    public pencilImage: Phaser.GameObjects.Image;
    public moveImage: Phaser.GameObjects.Image;
    public magnifyImage: Phaser.GameObjects.Image;
    public pencilImageColor: Phaser.GameObjects.Image;
    public pencilTween: Phaser.Tweens.Tween;
    public pencilColorTween: Phaser.Tweens.Tween;
    public hudContainer: Phaser.GameObjects.Container;
    public playingTween: boolean = false;

    public paintProgressBar: RavalProgressBar;
    public swapToMove: boolean = false;

    private homeButton: Phaser.GameObjects.Image;
    private eraseButton: RavalButton;
    private drawColors: Phaser.Display.Color[];
    private camManager: CameraManager;

    constructor(drawColors: Phaser.Display.Color[]) {

        super({
            key: "GuiScene"
        });
    }

    public init(data: any) { // Data type not exported?
        this.drawColors = data.drawColors;
    }

    public create(): void {

        GuiScene.currentInstance = this;

        // Add the palette B
        this.palette = new ColorPalette(this, this.drawColors);
        this.add.existing(this.palette);

        // Create container for the hud 
        this.hudContainer = new Phaser.GameObjects.Container(this, 0, 0);
        this.hudContainer.scaleX = GameVars.scaleXMult;
        this.hudContainer.scaleY = GameVars.scaleYMult;

        // Button HOME 
        this.homeButton = new RavalButton(this, 10, 10, "texture_atlas_1", "btn_home.png", "btn_home_over.png");
        this.homeButton.setOrigin(0);
        this.hudContainer.add(this.homeButton);

        // Create HOME callback
        this.homeButton.on("pointerup", function (): void {

            CanvasManager.sendCellsToPool();

            if (GameManager.getDrawState(GameVars.currentDrawCategoryID, GameVars.currentDrawId) !== drawState.DRAW_FINISHED) {
                GameManager.saveDrawData();
                GameManager.writeGameData();
            }

            if (GameConstants.SPONSOR === GameConstants.SPONSOR_LAGGED) {

                if (typeof prerollStart === "undefined") {

                        console.log("no ad found, resume game");
                        GuiScene.currentInstance.scene.start("LevelSelectionScene");
                    } else {
                        LaggedAPI.APIAds.show("interstitial","pixel-artist","pixel-artist-game.png",function(response) {
                            // ad completed
                            console.log("ad completed, resume game");
                            console.log("ad response:", response);
                            GuiScene.currentInstance.scene.start("LevelSelectionScene");
                        });
                    }
            } else if (GameConstants.SPONSOR === GameConstants.GAME_DISTRIBUTION) {
                if (typeof gdsdk !== "undefined" && gdsdk.showAd !== "undefined") {
                    gdsdk.showAd();
                    GameVars.typeAd = "Selection";
                } else {
                    this.scene.scene.start("LevelSelectionScene");
                }
            } else {
                this.scene.scene.start("LevelSelectionScene");
            }

        }, this);

        // Erase Button        
        this.eraseButton = new RavalButton(this, (GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse) - 10, 10, "texture_atlas_1", "btn_erase.png", "btn_erase_over.png", "", false);
        this.eraseButton.setPosition((GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse) - 10 - this.homeButton.width / 2, this.homeButton.y + this.homeButton.height / 2);
        this.hudContainer.add(this.eraseButton);

        this.eraseButton.on("pointerup", function () {

            AudioManager.playSound("paper_crumple");

            GameManager.deletePixelData(GameVars.currentDrawCategoryID, GameVars.currentDrawId);
            GameManager.setDrawState(GameVars.currentDrawCategoryID, GameVars.currentDrawId, drawState.DRAW_EMPTY);
            GameManager.writeGameData();

            CanvasScene.currentInstance.board.resetDrawing();
            CanvasManager.remarkCellsByID();
            CanvasManager.resetProgress();

            this.palette.resetElements();

            this.setEraseButtonEnabled(false);

        }, this);

        // Pencil Icon 
        this.pencilImage = new Phaser.GameObjects.Image(this, (GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse) / 2, this.eraseButton.y, "texture_atlas_1", "pencil_off.png");
        this.pencilImage.setOrigin(.5);

        this.pencilImageColor = new Phaser.GameObjects.Image(this, (GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse) / 2, this.eraseButton.y, "texture_atlas_1", "pencil_on.png");
        this.pencilImageColor.setScale(1.5);
        this.pencilImageColor.setOrigin(.5);
        this.pencilImageColor.visible = false;

        this.input.on("pointermove", function () {

            if (CanvasManager.currentScene.camManager.isDragging && !this.swapToMove) {

                this.pencilTween.pause();
                this.pencilImage.visible = false;
                this.pencilImageColor.visible = false;
                this.moveImage.visible = true;
                this.swapToMove = true;
            }

        }, this);

        this.input.on("pointerup", function () {

            if (this.input.activePointer.y > this.palette.getPaletteMinY()) {
                CanvasScene.currentInstance.unclickPointer();
            }
        }, this);

        this.pencilTween = this.tweens.create({
            targets: this.pencilImage,
            scaleX: 1.5,
            scaleY: 1.5,
            duration: 350,
            ease: Phaser.Math.Easing.Linear,
            paused: true,
            onComplete: function () {
                this.pencilImage.visible = false;
                this.pencilImageColor.visible = true;
                this.pencilColorTween.play(true);
            },
            onCompleteScope: this

        });

        this.pencilColorTween = this.tweens.create({
            targets: this.pencilImageColor,
            scaleX: 1,
            scaleY: 1,
            duration: 200,
            ease: "Back.easeOut",
        });

        this.hudContainer.add(this.pencilImage);
        this.hudContainer.add(this.pencilImageColor);

        // Move image
        this.moveImage = new Phaser.GameObjects.Image(this, (GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse) / 2, this.eraseButton.y, "texture_atlas_1", "drag_icon.png");
        this.moveImage.setOrigin(.5);
        this.moveImage.visible = false;
        this.hudContainer.add(this.moveImage);

        // Magnify image
        this.magnifyImage = new Phaser.GameObjects.Image(this, (GameConstants.GAME_WIDTH * GameVars.scaleXMultInverse) / 2, this.eraseButton.y, "texture_atlas_1", "magnify_icon.png");
        this.magnifyImage.setOrigin(.5);
        this.magnifyImage.visible = false;
        this.hudContainer.add(this.magnifyImage);

        // Add the hud to the scene 
        this.add.existing(this.hudContainer);

        CanvasManager.applySavedData();

        const drawingState = GameManager.getDrawState(GameVars.currentDrawCategoryID, GameVars.currentDrawId);
        if (drawingState === drawState.DRAW_FINISHED) {
            CanvasManager.paintAllCells(false);
            this.setEraseButtonEnabled(true);
        } else if (drawingState === drawState.DRAW_NULL || drawingState === drawState.DRAW_EMPTY) {
            this.setEraseButtonEnabled(false);
        }

    }

    public update(time: number, deltaTime: number): void {

        this.palette.update(deltaTime);

        if (!this.sys.game.device.os.desktop) {

            this.magnifyImage.visible = CanvasManager.currentScene.camManager.multiTouch;

            if (this.moveImage.visible && this.magnifyImage.visible) {
                this.moveImage.visible = false;
            }

            if (this.moveImage.visible || this.magnifyImage.visible) {
                this.pencilImage.visible = false;
                this.pencilImageColor.visible = false;
            }
        }
    }

    public refreshEraseButtonValidity(): void {

        let enabled = false;

        for (let i = 0; i < GameVars.colorCount.length; i++) {
            if (GameVars.colorCount[i] < GameVars.colorCountMax[i]) {
                enabled = true;
                break;
            }
        }

        this.setEraseButtonEnabled(enabled);
    }

    public setEraseButtonEnabled(enabled: boolean): void {

        if (this.eraseButton) {
            if (enabled) {
                this.eraseButton.input.enabled = true;
                this.eraseButton.alpha = 1;
            } else {
                this.eraseButton.input.enabled = false;
                this.eraseButton.alpha = .5;
            }
        }
    }

    public checkmarkPaletteElementWithID(id: number) {

        let element: PaletteElement = this.palette.getElement(id - 1);

        if (!element.isColorClosed()) {
            element.setClosed(true);
        }
    }

    public resetPencilTween(): void {

        this.pencilTween.pause();
        this.pencilTween.progress = 0;
        this.pencilImage.visible = true;
        this.pencilImage.setScale(1);

        this.pencilColorTween.pause();
        this.pencilColorTween.progress = 0;
        this.pencilImageColor.visible = false;
        this.pencilImageColor.setScale(1.5);

        this.pencilTween = this.tweens.create({
            targets: this.pencilImage,
            scaleX: 1.5,
            scaleY: 1.5,
            duration: 350,
            ease: Phaser.Math.Easing.Linear,
            paused: true,
            onComplete: function () {

                this.pencilImage.visible = false;
                this.pencilImageColor.visible = true;
                this.pencilColorTween.play(true);
            },
            onCompleteScope: this
        });
    }

    public onPointerUp(): void {

        this.resetPencilTween();

        this.moveImage.visible = false;
        this.pencilImage.visible = true;

        this.swapToMove = false;
    }
}

